import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getAdminVehicleTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/vehicle-types/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle types fetch error:", error);
    throw error;
  }
};

const getAdminVehicleTypeById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/vehicle-types/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle type fetch error:", error);
    throw error;
  }
};

const createVehicleType = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/vehicle-types/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle type create error:", error);
    throw error;
  }
};

const updateVehicleType = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/vehicle-types/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle type update error:", error);
    throw error;
  }
};

const deleteVehicleType = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin/vehicle-types/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle type delete error:", error);
    throw error;
  }
};

export {
  getAdminVehicleTypes,
  getAdminVehicleTypeById,
  createVehicleType,
  updateVehicleType,
  deleteVehicleType,
};
